let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iw7mH")).then(() => parcelRequire('3gW4g'));